/**
 * @generated SignedSource<<f78fe52edd83ef6c9ea15c71f74967f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PoiListRow_poi$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "PoiListRow_poi";
};
export type PoiListRow_poi$key = {
  readonly " $data"?: PoiListRow_poi$data;
  readonly " $fragmentSpreads": FragmentRefs<"PoiListRow_poi">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PoiListRow_poi",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "Poi",
  "abstractKey": null
};

(node as any).hash = "a4c37708c0ab4874303411e9b8384ea9";

export default node;
